// ONE source of truth for how the topic text fields are described to authors.
// Both the CLI help (apps/cli) and the MCP tool schema (apps/mcp) import these
// strings, so the two surfaces can never drift in what they tell an agent a
// field is for. The skill and docs are prose mirrors of the same wording.
//
// The model is content-first: `what` is a one-line summary, the real doc lives
// in `content`, and `how` is a SHORT note — not a place to paste a document.
export const FIELD_COPY = {
  what: 'One-sentence summary of what this is. The full explanation goes in content, not here.',
  how: 'Short — 1 to 3 sentences on the approach or mechanism. A full write-up belongs in content, not in how.',
  content: 'The full doc body (markdown). Long-form explanation, tables and code all live here.',
} as const

// A short field (`how`/`what`) over this many bytes is rejected by the API and
// pointed at `content` — the backstop for non-CLI clients. Generous: a few
// sentences fit easily; a pasted document does not.
export const MAX_SHORT_FIELD_BYTES = 8 * 1024

// Heuristic shared by the CLI write-time nudge, the API soft cap, and context
// doctor's `mis_shaped_how` check — ONE definition so all three agree on what
// "this short field looks like a whole document" means.
export function looksLikeDocument(s: string | null | undefined): boolean {
  if (!s) return false
  if (s.length > 1000) return true // far longer than 1–3 sentences
  if (/^\s*#{1,6}\s/m.test(s)) return true // markdown headings
  if (/^\s*\|[\s:|-]+\|\s*$/m.test(s)) return true // a GFM table separator row
  return false
}
